module.exports = __webpack_public_path__ + "img/maitre-gims.fea3a78d.jpg";